import { Anchor, Container } from "@mantine/core";

const Footer: React.FC = () => {
  return (
    <Container
      component="footer"
      py="lg"
      ta="center"
      bg="black"
      style={{ position: "relative", zIndex: 2 }}
      fluid
    >
      <Anchor href="/terms" target="_blank" c="white" fw="bold">
        Terms of Service
      </Anchor>
    </Container>
  );
};

export default Footer;
